/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturInstallIcon20Light = forwardRef('KonturInstallIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.164 10.457a1.25 1.25 0 1 0-.707.707l2.69 2.69a.5.5 0 0 0 .707-.708l-2.69-2.69Z" }),
        React.createElement("path", { d: "M9.842 6.003a.5.5 0 1 1-.04-1 5.063 5.063 0 0 1 4.113 1.887 5.063 5.063 0 0 1 .907 4.432.5.5 0 0 1-.964-.264 4.05 4.05 0 0 0-.726-3.546 4.05 4.05 0 0 0-3.29-1.509Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" })));
});
